import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { toast } from 'react-toastify';

const BulkUpdateDisplays = {
    name: 'BulkUpdateDisplays',
    state: {
        loading: false,
        error: '',
        success: false,
        results: null,
    },
    reducers: {
        assignRequested(state) {
            return {
                ...state,
                loading: true,
                error: '',
                success: false,
                results: null,
            };
        },

        assignSucceeded(state, payload) {
            return {
                ...state,
                loading: false,
                error: '',
                success: true,
                results: payload,
            };
        },

        assignFailed(state, payload) {
            return {
                ...state,
                loading: false,
                error: payload,
                success: false,
                results: null,
            };
        },
        resetState(state) {
            return {
                ...state,
                loading: false,
                error: '',
                success: false,
                results: null,
            };
        },
    },
    effects: (dispatch) => ({
        async bulkUpdateDisplays({ display_ids, visibility, rate_schedule_id, remove_rate_schedule = false, deactivate = false, select_all_matching = false, search = '', sorted_by = '', sort = '' }) {
            try {
                this.assignRequested();
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const url = `savvy/displays/bulk-update`;
                const payload = {
                    display_ids,
                    visibility,
                    rate_schedule_id,
                    remove_rate_schedule,
                    deactivate,
                    select_all_matching,
                    search,
                    sorted_by,
                    sort,
                    user_id: userInfo.id,
                    org_id: userInfo.org_id,
                };

                const response = await http.post(url, payload);

                if (response && response.data) {
                    this.assignSucceeded(response.data);
                    const { summary } = response.data.data || {};
                    
                    if (summary) {
                        if (summary.blocked_count > 0 || summary.failed_count > 0) {
                            toast.error(
                                `${summary.updated_count} updated, ${summary.blocked_count} blocked, ${summary.failed_count} failed. See details for more information.`,
                                { autoClose: 5000 }
                            );
                        } else if (summary.warned_count > 0 || summary.skipped_count > 0) {
                            toast.warning(
                                `${summary.updated_count} updated, ${summary.skipped_count} skipped, ${summary.warned_count} with warnings. See details for more information.`,
                                { autoClose: 5000 }
                            );
                        } else {
                            const count = summary.updated_count || 0;
                            const label = count === 1 ? 'display' : 'displays';
                            toast.success(
                                `${count} ${label} successfully updated.`,
                                { autoClose: 3000 }
                            );
                        }
                    } else {
                        toast.success(
                            response.data.message || 'Displays updated successfully!',
                            { autoClose: 3000 }
                        );
                    }

                    dispatch({
                        type: 'helper/show',
                        payload: {
                            type: 'success',
                            message: response.data.message || 'Displays updated successfully!',
                            show: true,
                        },
                    });
                    return { success: true, data: response.data };
                }
            } catch (err) {
                this.assignFailed(err.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
                return { success: false, error: err.message };
            }
        },
    }),
};

export default BulkUpdateDisplays;
